/* TypeScript file generated by genType. */
/* eslint-disable import/first */


// tslint:disable-next-line:no-var-requires
const TestFunctionsBS = require('./TestFunctions.bs');

export const strip0x: (_1:string) => string = TestFunctionsBS.strip0x;
